import { Card, Col, Empty, Row, Statistic } from "antd";
import { useEffect, useState } from "react";

import request from "@/api";
import { MyTaskAction } from "./MyTaskAction";

export interface MyTaskIndexStat {
    key: string;
    label: string;
    count: number;
    permissions?: readonly string[];
}

interface MyTaskIndexStatsProps {
    loadStats?: () => Promise<MyTaskIndexStat[]>;
}

const numberValue = (value: unknown) => Number(value || 0);

/** 复用 Vue 指数与资讯待办的七个统计接口。 */
export async function loadMyTaskIndexStats(): Promise<MyTaskIndexStat[]> {
    const [product, composite, freight, freightComposite, information, academy, oil] = await Promise.all([
        request.service.get("/admin/mytask/statisc/product-type-index-version"),
        request.service.get("/admin/mytask/statisc/composite-index"),
        request.service.get("/admin/mytask/statisc/shipping-price-index-version"),
        request.service.get("/admin/mytask/statisc/shipping-composite-index"),
        request.service.get("/admin/mytask/statisc/information"),
        request.service.get("/admin/mytask/statisc/sand-academy"),
        request.service.get("/admin/mytask/statisc/oil-index-version")
    ]);
    const productData = product.data || {};
    const compositeData = composite.data || {};
    const freightData = freight.data || {};
    const freightCompositeData = freightComposite.data || {};
    const informationData = information.data || {};
    const academyData = academy.data || {};
    const oilData = oil.data || {};
    return [
        {
            key: "productPending",
            label: "砂石指数待处理",
            count: numberValue(productData.pendingCount),
            permissions: ["ROLE_CATEGORY_INDEX_DEAL"]
        },
        {
            key: "productUnreleased",
            label: "砂石指数待发布",
            count: numberValue(productData.unreleasedCount),
            permissions: ["ROLE_CATEGORY_INDEX_MANAGE"]
        },
        {
            key: "composite",
            label: "砂石综合指数未发布",
            count: numberValue(compositeData.unPublished),
            permissions: ["ROLE_COMPSITE_INDEX_MANAGE"]
        },
        {
            key: "freightPending",
            label: "运价指数待处理",
            count: numberValue(freightData.pendingCount),
            permissions: ["ROLE_FREIGHT_RATE_DEAL"]
        },
        {
            key: "freightUnreleased",
            label: "运价指数待发布",
            count: numberValue(freightData.unreleasedCount),
            permissions: ["ROLE_FREIGHT_RATE_MANAGE"]
        },
        {
            key: "freightComposite",
            label: "运价综合指数未发布",
            count: numberValue(freightCompositeData.unPublished),
            permissions: ["ROLE_COMPSITE_FREIGHT_MANAGE"]
        },
        {
            key: "information",
            label: "资讯待上架",
            count: numberValue(informationData.unlistedCount),
            permissions: ["ROLE_INFO_W"]
        },
        {
            key: "academy",
            label: "砂石学院待上架",
            count: numberValue(academyData.unlistedCount),
            permissions: ["ROLE_SAND_ACADEMY_W"]
        },
        {
            key: "oilPending",
            label: "油品指数待处理",
            count: numberValue(oilData.pendingCount),
            permissions: ["ROLE_PETROL_INDEX_MANAGE"]
        },
        {
            key: "oilUnreleased",
            label: "油品指数未发布",
            count: numberValue(oilData.unreleasedCount),
            permissions: ["ROLE_PETROL_INDEX_MANAGE"]
        }
    ];
}

/** 指数与资讯待办统计卡片，沿用 Vue 的十类数量展示。 */
export function MyTaskIndexStats({ loadStats = loadMyTaskIndexStats }: MyTaskIndexStatsProps) {
    const [stats, setStats] = useState<MyTaskIndexStat[]>([]);

    useEffect(() => {
        let disposed = false;
        void loadStats().then(result => {
            if (!disposed) setStats(result);
        });
        return () => {
            disposed = true;
        };
    }, [loadStats]);

    return (
        <Card title="指数与资讯">
            {stats.length ? (
                <Row gutter={[16, 16]}>
                    {stats.map(stat => (
                        <Col key={stat.key} xs={12} sm={8} md={6}>
                            <MyTaskAction stat={stat}>
                                <Statistic title={stat.label} value={stat.count} />
                            </MyTaskAction>
                        </Col>
                    ))}
                </Row>
            ) : (
                <Empty description="暂无数据" />
            )}
        </Card>
    );
}
